import { globalGetService, globalPostService, globalPutService ,globalDeleteService} from '../../../utils_v2/globalApiServices';
import { checkApiStatus } from '../../../utils_v2';
import { toastFlashMessage } from '../../../utils';
export function getWetleaseListApi(props={}, query={}){
  globalGetService(`contracts/${props.params.contract_slug}/wet-lease/`, query)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({
        list: response.data.data
      })
    }
    this.setState({skeletonLoader:false});
  })
}
export function getWetleaseApi(props={}, id, mode){
  this.setState({pageLoader:true});
  globalGetService(`contracts/${props.params.contract_slug}/wet-lease/${id}/`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({ error:{}, wetlease:response.data.data, modal:true, mode: mode === 'V' ? 'view':'edit'})
    }
    this.setState({pageLoader:false});
  })
}
export function addEditWetleaseApi(props={}, data={}){
  return new Promise(
    function(resolve, reject){
      if(data.id){
        globalPutService(`contracts/${props.params.contract_slug}/wet-lease/${data.id}/`, data)
        .then(response => {
          resolve(response);
        })
      }else{
        globalPostService(`contracts/${props.params.contract_slug}/wet-lease/`, data)
        .then(response => {
          resolve(response);
        })
      }
    }
  )
}

export function deleteWetLeaseApi(props,deleteItem) {
  this.setState({pageLoader:true});
  globalDeleteService(`contracts/${props.params.contract_slug}/wet-lease/${deleteItem.data.id}/`)
    .then(response => {
      if (checkApiStatus(response)) {
        this.setState(prevState => ({
          ...prevState,
          list: prevState.list.filter((item, index) => item.id != deleteItem.data.id),
          deleteItem:{modal:false, data:null}
        }))
        toastFlashMessage(response?.data?.message, 'success')
      } else {
        toastFlashMessage(response?.data?.message, 'error')
      }
      this.setState({pageLoader:false});
    })
}
